import { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./index.css";

import PrivateRoute from "./components/PrivateRoute";


// import ViewRecipe from "./ViewRecipe";











import Home from "./Home";


















// import CreatePostPage from "./CreatePostPage";














import { Toaster } from 'react-hot-toast';

const ProfilePage = lazy(() => import("./ProfilePage"));
const LoginForm = lazy(() => import("./LoginForm"));
const RegisterConfirmation = lazy(() => import("./RegisterConfirmation"));
const ImageTest = lazy(() => import("./ImageTest"));
const ResetPassword = lazy(() => import("./ResetPassword"));
const Notifications = lazy(() => import("./Notifications"));
const ChatPage = lazy(() => import("./ChatPage"));
const UserProfile = lazy(() => import("./UserProfile"));
const MainPage = lazy(() => import("./MainPage"));
const Register = lazy(() => import("./Register"));
const EditProfile = lazy(() => import("./EditProfile"));
const WelcomeScreen = lazy(() => import("./WelcomeScreen"));
const PostDetail = lazy(() => import("./PostDetail"));
const ForgotPassword = lazy(() => import("./ForgotPassword"));
const PrivacyPolicy = lazy(() => import("./PrivacyPolicy"));
const AboutPage = lazy(() => import("./AboutPage"));
const Help = lazy(() => import("./Help"));
const Careers = lazy(() => import("./Careers"));
const Advertise = lazy(() => import("./Advertise"));
const CategoriesPage = lazy(() => import("./CategoriesPage"));
const NotFoundPage = lazy(() => import("./NotFoundPage"));
const MyRecipesPage = lazy(() => import("./MyRecipesPage"));
const SearchResultsPage = lazy(() => import("./SearchResultsPage"));
const RecipeDetailPage = lazy(() => import("./RecipeDetailPage"));
const PostEdit = lazy(() => import("./PostEdit"));
const PostSaved = lazy(() => import("./PostSaved"));
const FeatureChefs = lazy(() => import("./FeatureChefs"));
const CategoryDetail = lazy(() => import("./CategoryDetail"));
const TermsOfService = lazy(() => import("./TermsOfService"));
const VerifyEmail = lazy(() => import("./VerifyEmail"));
const OAuthCallback = lazy(() => import("./OAuthCallback"));
const SettingsScreen = lazy(() => import("./SettingsScreen"));
const DeleteAccount = lazy(() => import("./DeleteAccount"));
const ChangePassword = lazy(() => import("./ChangePassword"));
const CommunityGuidelines = lazy(() => import("./CommunityGuidelines"));
const FollowersPage = lazy(() => import("./FollowersPage"));
const FollowingPage = lazy(() => import("./FollowingPage"));
const CreatePage = lazy(() => import("./CreatePage"));

function App() {
  return (
    <Router>
      <Toaster position="top-center" reverseOrder={false} />
      <Suspense fallback={<div role="status" className="p-8 text-gray-500">Loading page…</div>}>
      <Routes>
        {/* Public landing = feed */}
      {/* Option A: The most standard way to match /@username/slug */}
  <Route path="/posts/:username/:slug" element={<PostDetail />} />
  {/* Option B: If the above fails, use the Splat (Catch-all) at the top */}
  <Route path="/posts/@:username/*" element={<PostDetail />} />
        <Route path="/" element={<Home />} />
          {/*  <Route path="/home" element={<Home />} /> */}

        {/* Public auth + legal pages */}
        <Route path="/login" element={<LoginForm />} />
        <Route path="/signup" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/register-confirmation" element={<RegisterConfirmation />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/help" element={<Help />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/advertise" element={<Advertise />} />
        <Route path="/verify/:token" element={<VerifyEmail />} />
        <Route path="/oauth/callback" element={<OAuthCallback />} />
        <Route path="/community-guidelines" element={<CommunityGuidelines />} />
        <Route path="/guidelines" element={<CommunityGuidelines />} />

        {/* Public content pages */}
        <Route path="/post/:post_uuid" element={<PostDetail />} />

        <Route path="/view-recipe/:recipe_uuid" element={<RecipeDetailPage />} />
        <Route path="/search" element={<SearchResultsPage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/category/:slug" element={<CategoryDetail />} />



        {/* Protected pages */}
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/edit-profile"
          element={
            <PrivateRoute>
              <EditProfile />
            </PrivateRoute>
          }
        />
        <Route
          path="/notifications"
          element={
            <PrivateRoute>
              <Notifications />
            </PrivateRoute>
          }
        />
<Route
          path="/chat"
          element={
            <PrivateRoute>
              <ChatPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/chat/:conversation_uuid"
          element={
            <PrivateRoute>
              <ChatPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/my-recipes"
          element={
            <PrivateRoute>
              <MyRecipesPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/create"
          element={
            <PrivateRoute>
              <CreatePage />
            </PrivateRoute>
          }
        />
        <Route path="/edit/:post_uuid" element={<PostEdit />} />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <SettingsScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/delete-account"
          element={
            <PrivateRoute>
              <DeleteAccount />
            </PrivateRoute>
          }
        />
        <Route
          path="/change-password"
          element={
            <PrivateRoute>
              <ChangePassword />
            </PrivateRoute>
          }
        />



 <Route
          path="/saved-posts"
          element={
            <PrivateRoute>
              <PostSaved />
            </PrivateRoute>
          }
        />



<Route
  path="/u/:id"
  element={
    <PrivateRoute>
      <UserProfile />
    </PrivateRoute>
  }
/>


<Route
  path="/followers"
  element={
    <PrivateRoute>
      <FollowersPage />
    </PrivateRoute>
  }
/>

<Route
  path="/following"
  element={
    <PrivateRoute>
      <FollowingPage />
    </PrivateRoute>
  }
/>

<Route
  path="/edit-recipe/:recipe_uuid"
  element={
    <PrivateRoute>
      <RecipeDetailPage />
    </PrivateRoute>
  }
/>

        {/* <Route path="/edit-recipes" element={<RecipeDetailPage />} /> */}

        {/* Misc / test */}
        <Route path="/test" element={<ImageTest />} />
        <Route path="/main" element={<MainPage />} />
        <Route path="/welcome" element={<WelcomeScreen />} />

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      </Suspense>
    </Router>
  );
}

export default App;

